/**
 * Match/payment accounting derived from meta.matchs (emission lives on document.entries).
 */
const MATCH_AMOUNT_EPS = 0.001;

export const isAccountableDocumentMatch = (match) => {
  if (!match) return false;
  const id = match.id ?? match.matchId;
  if (id == null || String(id).trim() === "") return false;
  const amount = Number(match.amount);
  return Number.isFinite(amount) && Math.abs(amount) > MATCH_AMOUNT_EPS;
};

export const summarizeDocumentMatchAccounting = (document) => {
  if (document?.matchAccounting && typeof document.matchAccounting === "object") {
    return document.matchAccounting;
  }

  const matches = [
    ...(document?.meta?.matchs?.inMatch || []),
    ...(document?.meta?.matchs?.outMatch || []),
  ].filter(isAccountableDocumentMatch);

  const completedCount = matches.filter((m) => m?.entries?.completed === true).length;
  const amount = matches.reduce((sum, m) => sum + Number(m?.entries?.amount || 0), 0);
  const pendingCount = matches.length - completedCount;

  return {
    applicable: matches.length > 0,
    completed: matches.length > 0 && pendingCount === 0,
    totalCount: matches.length,
    completedCount,
    pendingCount,
    amount,
  };
};

export const isDocumentFullyPaid = (remaining) => {
  if (remaining == null || remaining === "") return false;
  const n = Number(remaining);
  return Number.isFinite(n) && n <= MATCH_AMOUNT_EPS;
};

/** Same closed contract as the backend filter: DTE needs paid + emission + all match asientos. */
export const isDocumentAccountingClosed = (document, matchAccounting) => {
  const emissionDone = (document?.entries || document?.entryStatus)?.completed === true;
  if (String(document?.documentType || "") !== "TAX_DOCUMENT") {
    return emissionDone;
  }
  const remaining = document?.meta?.remaining ?? document?.remaining;
  const summary = matchAccounting || summarizeDocumentMatchAccounting(document);
  return (
    emissionDone &&
    isDocumentFullyPaid(remaining) &&
    summary.applicable === true &&
    summary.completed === true
  );
};
